import type { TenantSettings } from '@rp/contracts'
import { Card } from '../../design'
import { LockIcon } from './icons'
import { SETTINGS_COPY } from './copy'

const UNKNOWN = '—'

export const OperatorTerms = ({ fields }: { fields: TenantSettings['operatorFields'] | undefined }) => (
  <Card as="section" className="settings-card settings-terms">
    <section aria-label={SETTINGS_COPY.operator}>
      <div className="settings-terms-head">
        <LockIcon />
        <h2>{SETTINGS_COPY.operator}</h2>
      </div>
      <p className="settings-hint measure">{SETTINGS_COPY.operatorHint}</p>
      <dl className="settings-readonly">
        <dt>{SETTINGS_COPY.retentionDays}</dt>
        <dd className="num">{fields?.retentionDays ?? UNKNOWN}</dd>
        <dt>{SETTINGS_COPY.llmConcurrency}</dt>
        <dd className="num">{fields?.llmConcurrency ?? UNKNOWN}</dd>
      </dl>
    </section>
  </Card>
)
